import React, { useEffect, useRef } from "react";
import "./Location.css"; // Dein CSS-File für das Styling

const Location = () => {
  const infoRef = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2, // Trigger bei 20% Sichtbarkeit
    };

    const fadeInObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("fade-in");
        }
      });
    }, observerOptions);

    if (infoRef.current) fadeInObserver.observe(infoRef.current);
    if (mapRef.current) fadeInObserver.observe(mapRef.current);

    return () => fadeInObserver.disconnect();
  }, []);

  return (
    <div className="location-wrapper">
      <div className="location-inner">
        {/* Left Section: Contact Information and Opening Hours */}
        <div className="location-info fade-in-hidden" ref={infoRef}>
          <div className="company-info">
            <h2>Moon Lounge</h2>
            <p>Furtstraße 4, 73770 Denkendorf, Deutschland</p>
          </div>

          <div className="hours-info">
            <h2>Öffnungszeiten</h2>
            <p>So - Do: 18:00 - 01:00 Uhr</p>
            <p>Fr & Sa: 18:00 - 03:00 Uhr</p>
          </div>
        </div>

        {/* Right Section: Google Maps */}
        <div className="location-map fade-in-hidden" ref={mapRef}>
          <iframe
            title="Google Maps Location"
            src="https://www.google.com/maps?q=Furtstraße+4,+73770+Denkendorf&output=embed"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Location;
